module.exports = __webpack_public_path__ + "img/Map.318d5db3.svg";